import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "guan-result"
};
var _hoisted_2 = {
  key: 0,
  class: "center"
};
var _hoisted_3 = {
  class: "role-box"
};
var _hoisted_4 = {
  key: 2,
  class: "center"
};
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';
import IframeContainer from '@/components/IframeContainer/index.vue';
import { env_name, toLogin } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { getAuthSchoolList, saveCurrentSchool } from '@/api/boxiao.js';
import { routeAuth } from '@/utils/auth';
var defaultUrl = 'edudcs.zhixuehuijiao.cn/fe-pc/b/fe_exam_teacher';
export default {
  __name: 'index',
  setup: function setup(__props) {
    // 博校成绩管理
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      token = _storeToRefs.token;
    var bxUrl = ref('');
    var schoolList = ref([]);
    var currentSchoolId = ref('');
    var loading = ref(true);
    var hasAuth = ref(false);
    // 获取博校应用地址
    var getUrl = function getUrl() {
      var appUrl = defaultUrl;
      if (env_name === 'dev' || env_name === '') {
        appUrl = appUrl.replace('zhixuehuijiao.cn', 'zhixuehuijiao.cn');
      }
      var url = "//".concat(env_name).concat(appUrl, "?bayToken=").concat(token.value);
      return url;
    };
    bxUrl.value = getUrl();

    // 获取学校列表
    var getSchoolList = function getSchoolList() {
      getAuthSchoolList().then(function (res) {
        schoolList.value = res.data.data.map(function (item) {
          return {
            label: item.schoolName,
            value: item.schoolId,
            isCurrentSchool: item.isCurrentSchool
          };
        });
        var currentSchool = schoolList.value.filter(function (item) {
          return item.isCurrentSchool;
        });
        if (currentSchool && currentSchool.length) {
          currentSchoolId.value = currentSchool[0].value;
        } else {
          currentSchoolId.value = schoolList.value[0].value;
        }
        changeSChool(currentSchoolId.value);
      });
    };
    var handleAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var auth, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return routeAuth('boxiaoAchievementManage');
            case 1:
              auth = _context.v;
              console.log(auth, 191919);
              hasAuth.value = auth;
              _context.n = 2;
              return auth;
            case 2:
              _t = _context.v;
              if (!_t) {
                _context.n = 3;
                break;
              }
              getSchoolList();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t2 = _context.v;
              console.error('Failed to get route auth:', _t2);
              hasAuth.value = false;
            case 5:
              _context.p = 5;
              loading.value = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[0, 4, 5, 6]]);
      }));
      return function handleAuth() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(function () {
      handleAuth();
    });

    // 切换学校
    var changeSChool = function changeSChool(id) {
      saveCurrentSchool(id).then(function (res) {
        bxUrl.value = bxUrl.value + "?schoolId=".concat(id);
      });
    };
    var handleChangeSchool = function handleChangeSchool() {
      changeSChool(currentSchoolId.value);
    };
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_t_select = _resolveComponent("t-select");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading)])) : _createCommentVNode("", true), !loading.value && hasAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_t_select, {
        modelValue: currentSchoolId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return currentSchoolId.value = $event;
        }),
        options: schoolList.value,
        onChange: handleChangeSchool
      }, null, 8, ["modelValue", "options"])]), _createVNode(IframeContainer, {
        src: bxUrl.value
      }, null, 8, ["src"])], 64)) : _createCommentVNode("", true), !loading.value && !hasAuth.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Empty, {
        text: "暂无应用权限"
      })])) : _createCommentVNode("", true)]);
    };
  }
};